import React, { useRef, useCallback, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import {
  ButtonGroup
} from 'react-bootstrap'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import Button from 'components/Button'
import KanBoIcon from 'components/KanBoIcon'
import KanBoUserPicker from 'components/KanBoUserPicker'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'

export function AddUserToLayout ({
  layoutId,
  permissionLevel,

  permission,

  requestAddUserToLayout,

  leftSidebar
}) {
  const kanBoUserPickerRef = useRef(null)

  useEffect(() => {
    if (!permission.owner) {
      leftSidebar.pop()
    }
  }, [permission.owner, leftSidebar])

  const handleAddUserClick = useCallback(() => {
    const users = kanBoUserPickerRef.current.getSelectedUsers()

    users.forEach(userId => requestAddUserToLayout({
      layoutId,
      userId,
      permissionLevel
    }))

    leftSidebar.pop()
  }, [layoutId, permissionLevel, requestAddUserToLayout, leftSidebar])

  const handleCancelClick = useCallback(() => {
    leftSidebar.pop()
  }, [leftSidebar])

  return (
    <LeftSidebarView
      title={<FormattedMessage id='USERS_ADD' />}
    >
      <KanBoUserPicker
        ref={kanBoUserPickerRef}
      />
      <ViewBody className='p-10'>
        <ButtonGroup>
          <Button
            bsStyle='primary'
            icon={<KanBoIcon name='kanbo-16-plus' />}
            onClick={handleAddUserClick}
          >
            <FormattedMessage id='ADD_SELECTED' />
          </Button>
          <Button
            onClick={handleCancelClick}
          >
            <FormattedMessage id='CANCEL' />
          </Button>
        </ButtonGroup>
      </ViewBody>
    </LeftSidebarView>
  )
}

export default withLeftSidebar(AddUserToLayout)
